(() => {
  const messages = {
    de: { summary: 'Bitte korrigiere die folgenden Felder:', required: 'Dieses Feld ist erforderlich.', email: 'Gib eine gültige E-Mail-Adresse ein.', min: 'Der Wert muss mindestens {value} sein.', max: 'Der Wert darf höchstens {value} sein.', pattern: 'Gib einen Wert im erforderlichen Format ein.', invalid: 'Prüfe den eingegebenen Wert.' },
    fr: { summary: 'Veuillez corriger les champs suivants :', required: 'Ce champ est obligatoire.', email: 'Saisissez une adresse e-mail valide.', min: 'La valeur doit être au moins {value}.', max: 'La valeur ne doit pas dépasser {value}.', pattern: 'Saisissez une valeur au format requis.', invalid: 'Vérifiez la valeur saisie.' },
    en: { summary: 'Please correct the following fields:', required: 'This field is required.', email: 'Enter a valid email address.', min: 'The value must be at least {value}.', max: 'The value must be no more than {value}.', pattern: 'Enter a value in the required format.', invalid: 'Check the value entered.' },
    ar: { summary: 'يرجى تصحيح الحقول التالية:', required: 'هذا الحقل مطلوب.', email: 'أدخل عنوان بريد إلكتروني صالحاً.', min: 'يجب ألا تقل القيمة عن {value}.', max: 'يجب ألا تزيد القيمة عن {value}.', pattern: 'أدخل قيمة بالتنسيق المطلوب.', invalid: 'تحقّق من القيمة المدخلة.' }
  };
  const selector = '[data-native-search],[data-hlx-form],[data-asv-form],[data-b2br-form],[data-llt-form],[data-kg-form],.proxy-form,#CorporateChristmasInquiry';
  const locale = (document.documentElement.lang || 'de').slice(0, 2);
  const text = messages[locale] || messages.de;
  let nextId = 0;
  const prepare = (scope) => {
    if (scope instanceof HTMLFormElement && scope.matches(selector)) scope.noValidate = true;
    scope.querySelectorAll?.(selector).forEach(form => {
      form.noValidate = true;
    });
  };
  prepare(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node instanceof HTMLElement) prepare(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });

  const fieldLabel = (field) => {
    const labelled = field.getAttribute('aria-label');
    if (labelled) return labelled;
    const label = field.labels?.[0];
    return label?.textContent.replace(/\s+/g, ' ').trim() || field.name;
  };
  const validationMessage = (field) => {
    const validity = field.validity;
    if (validity.valueMissing) return text.required;
    if (validity.typeMismatch && field.type === 'email') return text.email;
    if (validity.rangeUnderflow) return text.min.replace('{value}', field.min);
    if (validity.rangeOverflow) return text.max.replace('{value}', field.max);
    if (validity.patternMismatch) return text.pattern;
    return text.invalid;
  };
  const ensureId = (field) => {
    if (!field.id) field.id = `StorefrontField-${++nextId}`;
    return field.id;
  };
  const clearField = (field) => {
    const errorId = field.dataset.validationError;
    if (errorId) document.getElementById(errorId)?.remove();
    delete field.dataset.validationError;
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-errormessage');
    const described = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== errorId);
    if (described.length) field.setAttribute('aria-describedby', described.join(' '));
    else field.removeAttribute('aria-describedby');
  };
  const clear = (form) => {
    form.querySelector('[data-validation-summary]')?.remove();
    [...form.elements].forEach(field => {
      if (field instanceof HTMLElement) clearField(field);
    });
  };
  const render = (form, focus = true) => {
    clear(form);
    const invalid = [...form.elements].filter(field => typeof field.checkValidity === 'function' && !field.checkValidity());
    if (!invalid.length) return true;
    const summary = document.createElement('div');
    summary.className = 'validation-summary';
    summary.dataset.validationSummary = '';
    summary.setAttribute('role', 'alert');
    summary.setAttribute('tabindex', '-1');
    const heading = document.createElement('p');
    heading.className = 'validation-summary__title';
    heading.textContent = text.summary;
    const list = document.createElement('ul');
    invalid.forEach(field => {
      const id = ensureId(field);
      const errorId = `${id}-error`;
      const message = validationMessage(field);
      const inline = document.createElement('span');
      inline.id = errorId;
      inline.className = 'field-error';
      inline.textContent = message;
      const container = field.closest('label,[class*="input-group"]') || field.parentElement;
      container?.append(inline);
      field.dataset.validationError = errorId;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-errormessage', errorId);
      const described = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      described.add(errorId);
      field.setAttribute('aria-describedby', [...described].join(' '));
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${CSS.escape(id)}`;
      link.textContent = `${fieldLabel(field)}: ${message}`;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        field.focus();
      });
      item.append(link);
      list.append(item);
    });
    summary.append(heading, list);
    form.prepend(summary);
    if (focus) summary.focus();
    return false;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(selector) || form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    render(form);
  }, true);
  document.addEventListener('input', (event) => {
    const field = event.target;
    const form = field.form;
    if (!form?.matches(selector) || !field.dataset.validationError) return;
    if (field.checkValidity()) render(form, false);
  });
  document.addEventListener('change', (event) => {
    const field = event.target;
    const form = field.form;
    if (!form?.matches(selector) || !field.dataset.validationError) return;
    if (field.checkValidity()) render(form, false);
  });
})();